import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SOCIETY_CONTROLLER } from "../../../Routing/routes";
import AdminUsersListLayer from "./Component/AdminUsersListLayer";

const AdminUsers = () => {
    const links = [{ to: SOCIETY_CONTROLLER + "/admin-users", text: 'Users' }]

    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                description='Configure and manage admin users on the platform'
                links={links}
                headingTitle="Users"
            />
            <AdminUsersListLayer />
        </>
    );
};

export default AdminUsers;
